import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Modal } from "../common/Modal";
import { FormActions } from "../common/FormActions";
import { MultipleFileUploader } from "../common/MultipleFileUploader";
import { createMenuJob } from "../../service/menuJobService";
import { getRestaurantId } from "../../utils/JwtUtil";
import { S3_BASE_URL } from "../../utils/Constants";

export function MenuJobModal({ onClose }) {
  const { t } = useTranslation();
  const qc = useQueryClient();
  const restaurantId = getRestaurantId();
  const [imageKeys, setImageKeys] = useState([]);

  const mutation = useMutation({
    mutationFn: createMenuJob,
    onSuccess: () => {
      qc.invalidateQueries(["menuJobs", restaurantId]);
      setImageKeys([]);
      onClose();
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    const imageUrls = imageKeys.map(key => `${S3_BASE_URL}/${key}`);
    mutation.mutate({ restaurantId, imageUrls });
  };

  return (
    <Modal title={t("uploadMenuAI")} onClose={onClose}>
      <form onSubmit={handleSubmit} className="space-y-4">
        <MultipleFileUploader
          label={t("uploadImages")}
          onUploadComplete={setImageKeys}
          t={t}
        />
        {imageKeys.length > 0 && (
          <div className="space-y-1">
            {imageKeys.map((k) => (
              <div key={k} className="text-sm">
                <code>{k}</code>
              </div>
            ))}
          </div>
        )}
        <FormActions
          isLoading={mutation.isLoading}
          onCancel={onClose}
          submitLabel={t("upload")}
        />
      </form>
    </Modal>
  );
}
